<template>
  <div style="height: 100%;">
    <slot name="list-title">
      <div v-if="getField(options, 'title')" class="group-title"><span v-html="getField(options, 'title')" /></div>
    </slot>
    <template v-for="group in groups">
      <div v-if="group.title" class="group-title">
        <slot :group="group" name="group-title">
          <span v-html="group.title" />
        </slot>
      </div>
      <div class="ui" style="width:100%;">
        <div class="ui very relaxed divided a-nimated list">
          <a v-for="item in group.items" :key="getField(item, itemValueField)"
             :class="item && itemClass(item)"
             class="item"
             @click="selectListItem(item)"
          >
            <slot :item="item" :options="options">
              <list-item :item="item" :item-render-options="options.itemRenderOptions" />
            </slot>
          </a>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import ListItem from './ListItem'
import getField from '@/utils/getField'

export default {
  components: {
    ListItem
  },
  props: {
    items: Array,
    selectedItem: Object,
    itemValueField: {
      // type: String,
      default: 'id'
    },
    modifiedItemsKeys: {
      type: Array,
      default () {
        return []
      }
    },
    options: {
      type: Object,
      default () {
        return {
          groupOptions: false,
          bordered: false,
          itemRenderOptions: {
            // can be name of item field or function(item) that returns string
            headerField: 'name',
            descriptionField: null
          }
        }
      }
    }
  },
  watch: {
    selectedItem: function (newValue, oldValue){
      this.currentSelectedItem = newValue
    }
  },
  data () {
    return {
      currentSelectedItem: this.selectedItem
    }
  },
  computed: {
    groups () {
      let self = this
      let groupHeaderField = getField(self, 'options.groupOptions.headerField', 'name')
      let groupItemsField = getField(self, 'options.groupOptions.itemsField', 'items')
      if (this.options && this.options.groupOptions) {
        let groupItems = []
        this.items.map(function (groupItem) {
          groupItems.push({
            title: getField(groupItem, groupHeaderField),
            items: getField(groupItem, groupItemsField, [])
          })
        })
        return groupItems
      } else {
        return [{items: this.items}]
      }
    }
  },
  methods: {
    getField,
    selectListItem (item) {
      if (this.currentSelectedItem != null && item != null &&
          getField(this.currentSelectedItem, this.itemValueField) === getField(item, this.itemValueField)) {
        this.currentSelectedItem = null
      } else {
        this.currentSelectedItem = item
      }
      this.$emit('change', this.currentSelectedItem)
    },
    isCurrentItem (item) {
      return this.currentSelectedItem != null && getField(this.currentSelectedItem, this.itemValueField) === getField(item, this.itemValueField)
    },
    itemClass (item) {
      let isItemModified = this.modifiedItemsKeys.indexOf(getField(item, this.itemValueField)) >= 0
      return {
        'bordered': this.options.bordered,
        'active': this.isCurrentItem(item),
        'new-item': isItemModified && item.isNew,
        'modified': isItemModified && !item.isNew
      }
    }
  }
}
</script>

<style scoped>
  .group-title {
    padding: 10px;
    background-color: #5e7b9b;
    color: #ffffff;
  }
  .item {
    /*padding-left: 1rem !important;*/
    /*padding-right: 1rem !important;*/
    border-left: 3px solid transparent;
    display: block;
  }
  .item.bordered {
    border-bottom: 1px solid #e2e2e2;
    border-top: 1px solid #ffffff;
  }
  .item:hover, .item.active {
    background-color: #ffffff;
    border-color: #adbbca;
  }

  .ui.list>.item {
    padding-top: .85714286em;
    padding-bottom: .85714286em;
  }

  /*
  .ui.list .list>.item:first-child
  , .ui.list>.item:first-child
  , ol.ui.list li:first-child
  , ul.ui.list li:first-child {
    padding-top: .85714286em;
  }
  .ui.list .list>.item:last-child
  , .ui.list>.item:last-child
  , ol.ui.list li:last-child
  , ul.ui.list li:last-child {
    padding-bottom: .85714286em;
  }
  */
</style>



// WEBPACK FOOTER //
// src/components/layout/List/index.vue